/** Use on back `/sender/*` mutations when the UI shows errors via `resolveSenderActionError`. */
export const senderBackSuppressErrorToast = { suppressToast: true };
